<template>
    <div class="business_cooperation_container" id="business_cooperation">
        <div class="business_cooperation_main">
            <div class="business_cooperation_title">{{ $t('index.business_cooperation_title') }}</div>
            <div class="business_cooperation_desc">{{ $t('index.business_cooperation_desc') }}</div>
            <div class="business_cooperation_step_box">
                <div class="step_box">
                    <div class="step_num">01</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step01_tit') }}</div>
                </div>

                <div class="step_arrow">
                    <img src="@/assets/static/imgs/common/arrow.png" alt="">
                </div>

                <div class="step_box">
                    <span class="step_num">02</span>
                    <div class="step_tit">{{ $t('index.business_cooperation_step02_tit') }}</div>
                </div>

                <div class="step_arrow">
                    <img src="@/assets/static/imgs/common/arrow.png" alt="">
                </div>

                <div class="step_box">
                    <div class="step_num">03</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step03_tit') }}</div>
                </div>

                <div class="step_arrow">
                    <img src="@/assets/static/imgs/common/arrow.png" alt="">
                </div>

                <div class="step_box">
                    <div class="step_num">04</div>
                    <div class="step_tit">{{ $t('index.business_cooperation_step04_tit') }}</div>
                </div>
            </div>

            <div class="business_cooperation_form_box" v-lazy:background-image="require('@/assets/static/imgs/home/bg-form.png')">
                <div class="business_cooperation_form">
                    <div class="form_title">{{ $t('index.business_cooperation_form_tit') }}</div>
                    <div class="form_body">
                        <el-form ref="form" :model="form" :rules="rules">
                            <div>
                                <el-form-item prop="name">
                                    <el-input 
										v-model="form.name" 
										:placeholder="$t('index.business_cooperation_form_placeholder_name')"></el-input>
                                </el-form-item>

                                <el-form-item prop="phone" class="phone-input-sty">
                                    <el-input 
										v-if="false" 
										v-model="form.phone" 
										:placeholder="$t('index.business_cooperation_form_placeholder_phone')"></el-input>
									<vue-phone-number-input 
										ref="phoneInput" 
										v-model="form.phone" 
										:default-country-code="countryCode" 
										@update="onUpdate" 
										id="botPhone" />
                                </el-form-item>
                            </div>

                            <div>
                                <el-form-item prop="company">
                                    <el-input 
										v-model="form.company" 
										:placeholder="$t('index.business_cooperation_form_placeholder_company')"></el-input>
                                </el-form-item>
                                
                                <el-form-item prop="email">
                                    <el-input 
										v-model="form.email" 
										:placeholder="$t('index.business_cooperation_form_placeholder_email')"></el-input>
                                </el-form-item>

                                <el-button type="primary" @click="submitForm('form')">
                                    {{ $t('index.business_cooperation_form_button') }}
                                </el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formRules          from '@/utils/formRules';
import { postFormJoinUs } from '@/api/joinUsApi';

export default {
    name: 'CommonBusinessCooperationPc',
    data() {
        return {
            tips: 'Hello World',
            // About Phone
			results    : null,
			countryCode: 'CN',
			form       : {
				name       : '',
				countryCode: '',// 86
				phone      : '',// 132 1234 5678
				company    : '',
				email      : ''
			},
			rules: {
				name   : formRules.nameRules(this),
				phone  : formRules.phoneRules(this),
				company: formRules.companyRules(this),
				email  : formRules.emailRules(this)
			}
        }
    },

    methods: {
		// 获取电话信息的不同样式
		onUpdate(payload)
		{
			this.results = payload;
			// console.log('=== onUpdate__results >>>', this.results);

			// 让ERROR隐藏
			var botPhone = document.getElementById('botPhone');
			if(botPhone.nextElementSibling)
			{
				var nextElement = botPhone.nextElementSibling;
				nextElement.style.display = 'none';
			}

			this.$set(this.form, 'countryCode', this.results.countryCallingCode);// 86
			this.$set(this.form, 'phone', this.results.phoneNumber);             // 132 1234 5678
    	},

        // Submit Form
		async submitForm(formName)
		{
			this.$refs[formName].validate(async (valid) => {
				if(valid)
				{
					// Req
					/* console.log('=== submitForm__this__form >>>', this.form);
					return; */

					const res = await postFormJoinUs(this.form);
					// console.log('=== submitForm > res >>>', res);

					// 关闭输入弹窗
					// this.closeFormDialog();
					this.$refs.form.resetFields();
					
					if(res && res.errCode === 0)
					{
						this.$message({
							type       : 'success',
							customClass: 'zdyElMsg',
							message    : res.errMsg
						});
					}
					else if(res && res.errCode !== 0)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : res.errMsg
						});
					}
					else
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : 'The operation failed. Please try again later~'
						});
					}
				}
				else
				{
					// console.log('=== this.form.phone >>>', this.form.phone);
					// console.log('=== this.form.valid >>>', valid);

					// 提交时：未输入手机号
					if(this.form.phone === null)
					{
						this.$message({
							type       : 'warning',
							customClass: 'zdyElMsg',
							message    : 'The operation failed. Please try again later~'
						});
					}
					else
					{
						// console.log('=== this.form.phone >>>', this.form.phone);
						const phoneNumberWithoutSpaces = this.form.phone.replace(/\s/g, '');// 移除所有空格
						const phoneNumberLength        = phoneNumberWithoutSpaces.length;
						if(phoneNumberLength < 5 || phoneNumberLength > 30)
						{
							this.$message({
								type       : 'warning',
								customClass: 'zdyElMsg',
								message    : 'Phone format error~'
							});
						}
					}
					
					console.log('=== ERROR SUBMIT <<<');
					return false;
				}
			});
		}
    },

	mounted() {
		// 修改 vue-phone-number-input 插件的 placeholder 属性
		this.$nextTick(() => {
			const phoneInputElement = this.$refs.phoneInput.$el.querySelector('.input-phone-number input');
			if(phoneInputElement)
			{
				phoneInputElement.placeholder = this.$t('index.business_cooperation_form_placeholder_phone');
			}
		});
	}
}
</script>

<style lang="less" scoped>
.business_cooperation_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h3);
	background:linear-gradient(180deg, #FFF, #F4F8FF, #DBE9FF, #D0E2FF);
	.business_cooperation_main{
		position:relative;
		margin:0 auto;padding-top:75px;
		width:var(--com-base-container-w);height:inherit;
		/* background:#CCC; */
		.business_cooperation_title{
			height:50px;line-height:50px;
			font-size:var(--com-base-fz-48);font-weight:bold;color:var(--com-main-ft-color);text-align:center;
		}
		.business_cooperation_desc{
			display:flex;justify-content:center;align-items:center;
			margin-top:10px;
			height:50px;line-height:60px;
			font-size:var(--com-base-fz-22);font-weight:normal;color:#676D77;text-align:center;
		}
		.business_cooperation_step_box{
			width:100%;margin-top:125px;
			display:flex;justify-content:space-between;align-items:center;
			/* gap:40px; */
			.step_box{
				position:relative;
				width:282px;height:110px;
				border:2px solid #FBFDFF;border-radius:14px;
				background:#FFF;
				.step_num{
					position:absolute;top:-38px;left:0;right:0;margin:auto;
					font-size:var(--com-base-fz-54);font-weight:bold;font-style:italic;color:#1D55FF;text-align:center;
					text-shadow:3px 4px 4px #B7D0F4;
				}
				.step_tit{
					text-align:center;
					font-size:var(--com-base-fz-22);color:#676D77;
					margin-top:40px;
				}
			}
			.step_arrow{
				width:20px;height:16px;
				img{
					width:inherit;height:inherit;
				}
			}
		}
		.business_cooperation_form_box{
			border:2px solid #F6FAFF;border-radius:18px;
			width:100%;height:242px;
			margin-top:110px;padding:20px;
			background:#E7F0FF;
			background-position:110px 15px;
			background-repeat:no-repeat;
			background-size:253px 244px;
			display:flex;justify-content:flex-end;align-items:center;
			.business_cooperation_form{
				width:70%;
				display:flex;flex-direction:column;justify-content:center;align-items:center;
				.form_title{
					width:100%;height:40px;line-height:15px;
					font-size:var(--com-base-fz-24);font-weight:bold;color:var(--com-main-ft-color);
					padding-left:15px;
				}
				.form_body{
					width:100%;
					/deep/ .el-form{
						div{
							display:flex;justify-content:flex-start;align-items:center;
							.el-form-item{
								margin-bottom:18px !important;
								.el-form-item__content{
									.el-input{
										font-size:var(--com-base-fz-16);
										input.el-input__inner{
											width:282px;height:50px;line-height:1;
											margin-right:25px;padding:0 15px;
											border-radius:25px !important;
											border:none !important;
											transition:all .25s cubic-bezier(.645,.045,.355,1);
											background:#FAFBFC;
											&:focus{
												border-color:#409EFF;
												box-shadow:rgba(30, 144, 255,	0.7) 0px 0px 0px 2px;
											}
										}
										input.el-input__inner::placeholder{
											font-size:var(--com-base-fz-16);color:#d2c3cc;
										}
									}
									.el-form-item__error{
										padding-top:4px;
										font-size:var(--com-base-fz-12);
									}
								}
							}
						}
						div:nth-child(2){
							.el-form-item{
								margin-bottom:0px !important;
							}
							button{
								width:160px;height:50px;
								border-radius:25px;border:none;
								background:#1D55FF;
								span{
									font-size:var(--com-base-fz-18);font-weight:bold;color:#FFF !important;
								}
							}
							.el-button{
								padding:12px 20px;
								font-size:var(--com-base-fz-18);
							}
						}

						.phone-input-sty, 
						.phone-input-sty .el-form-item__content,
						.vue-phone-number-input{
							flex-direction:row !important;
							.select-country-container{
								width:90px !important;min-width:90px;max-width:90px;
								margin-right:10px;
							}
							.country-selector{
								width:90px;height:50px !important;
								.country-selector__label{display:none;}
								.country-selector__country-flag{
									display:none;
									top:27px;left:11px;
								}
								.country-selector__input{
									height:inherit;min-height:50px !important;
									border:none !important;
									border-top-left-radius:25px !important;
									border-top-right-radius:8px !important;
									border-bottom-right-radius:8px !important;
									border-bottom-left-radius:25px !important;
									border-right:none !important;
									font-size:var(--com-base-fz-13);
									background:#FAFBFC;
									transition:all .25s cubic-bezier(.645,.045,.355,1);
								}
								&.has-value{
									.country-selector__input{
										padding-top:unset !important;
										padding-left:28px !important;
									}
								}
							}
							.country-selector__label, .input-tel__label{
								display:none;
								top:-10px !important;left:11px !important;
								font-size:var(--com-base-fz-11);
							}
							.country-selector.has-value .country-selector__label{
								font-size:var(--com-base-fz-11);
							}
							.country-selector__list{
								left:0px;top:55px;
								width:282px !important;min-width:282px !important;
								height:217px !important;max-height:217px !important;
								border-radius:8px !important;
								flex-direction:column;
								background:#FAFBFC;
								padding-left:10px;
								div{
									flex-direction:column;
								}
								.country-selector__list__item{
									width:282px !important;min-width:282px !important;
									background:transparent !important;
									div{
										align-items:flex-start;
									}
								}
							}			
							.input-tel{
								width:182px !important;height:50px !important;
								min-height:50px !important;
								.input-tel__input{
									height:inherit;min-height:50px !important;
									border:none !important;
									border-top-left-radius:8px !important;
									border-top-right-radius:25px !important;
									border-bottom-right-radius:25px !important;
									border-bottom-left-radius:8px !important;
									/* border-left:none !important; */
									font-size:var(--com-base-fz-16);
									background:#FAFBFC;
									padding-top:unset !important;
									/* &:hover{
										border-color:#409EFF !important;
									} */
								}
								input.input-tel__input::placeholder{
									font-size:var(--com-base-fz-16);color:#d2c3cc;
								}
							}
							.country-selector__list__item__flag-container{
								display:none;
							}
							.is-focused{
								input.country-selector__input{
									/* border-color:#409EFF; */
									box-shadow:rgba(30, 144, 255,	0.7) 0px 0px 0px 2px;
								}
							}
							.is-focused{
								input.input-tel__input{
									/* border-color:#409EFF; */
									box-shadow:rgba(30, 144, 255,	0.7) 0px 0px 0px 2px;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>
